<div class="chips-container">
  <ng-content></ng-content>
  <rms-filter-chip-option [item]="item" *ngFor="let item of items" (onDelete)="onDeleteOptionHandler($event)"></rms-filter-chip-option>
  <!-- Trailing slot: flows after the last chip in the same wrapping row. -->
  <ng-content select="[chipListEnd]"></ng-content>
</div>
